import React from 'react';
import { TailSpin, BallTriangle } from 'react-loader-spinner';
import classNames from 'classnames';

import './style.css';

interface DataLoaderProps extends React.HTMLProps<HTMLDivElement> {
  color: string;
  size: number;
  type?: 'BallTriangle' | 'TailSpin';
}

const DataLoader: React.FC<DataLoaderProps> = props => {
  const { color, size, type = 'BallTriangle', className } = props;
  const loaderClassName = classNames('data-loader', className);

  if (type === 'TailSpin') {
    return <TailSpin wrapperClass={loaderClassName} color={color} height={size} width={size} />;
  }

  return <BallTriangle wrapperClass={loaderClassName} color={color} height={size} width={size} />;
};

export default DataLoader;
